import { createContext, useContext, useState, useCallback } from 'react';

const GaugeSimulationContext = createContext(null);

const defaultGauge = () => ({ capacityMW: 24, producingMW: 10 });

export function GaugeSimulationProvider({ children }) {
  const [capacityMW, setCapacityMW] = useState(24);
  const [producingMW, setProducingMW] = useState(10);
  const [gaugeByCompanyId, setGaugeByCompanyId] = useState({});

  const setCompanyGauge = useCallback((companyId, { capacityMW: cap, producingMW: prod }) => {
    setGaugeByCompanyId((prev) => ({
      ...prev,
      [companyId]: { capacityMW: cap, producingMW: prod }
    }));
  }, []);

  const getCompanyGauge = useCallback((companyId) => {
    const g = gaugeByCompanyId[companyId];
    return g || defaultGauge();
  }, [gaugeByCompanyId]);

  return (
    <GaugeSimulationContext.Provider
      value={{
        capacityMW,
        setCapacityMW,
        producingMW,
        setProducingMW,
        gaugeByCompanyId,
        setCompanyGauge,
        getCompanyGauge
      }}
    >
      {children}
    </GaugeSimulationContext.Provider>
  );
}

export function useGaugeSimulation() {
  const ctx = useContext(GaugeSimulationContext);
  return (
    ctx || {
      capacityMW: 24,
      setCapacityMW: () => {},
      producingMW: 10,
      setProducingMW: () => {},
      gaugeByCompanyId: {},
      setCompanyGauge: () => {},
      getCompanyGauge: () => defaultGauge()
    }
  );
}
